module.exports = __webpack_public_path__ + "static/media/coins-desktop--3.8b5236cc.svg";